import { render, staticRenderFns } from "./Professionals.vue?vue&type=template&id=a5a0a4a0&scoped=true&"
import script from "./Professionals.vue?vue&type=script&lang=js&"
export * from "./Professionals.vue?vue&type=script&lang=js&"
import style0 from "./Professionals.vue?vue&type=style&index=0&id=a5a0a4a0&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a0a4a0",
  null
  
)

export default component.exports